import { defineStore } from 'pinia';
import { getData } from '@/services/axios-service';
import { BASE_URL } from '@/utils/constants/api-constants';
import { WebflowState } from '@/interfaces/webflow/webflow.interface';

const INITIAL_STATE: WebflowState = {
  postsData: {
    posts: null,
    authors: null,
    locations: null,
    categories: null,
  },
  mergedData: null,
  todayPosts: null,
};

export const useWebflowStore = defineStore({
  id: 'WebflowStore',
  state: (): WebflowState => ({
    ...INITIAL_STATE,
  }),
  actions: {
    async getCollections(type: 'posts' | 'authors' | 'locations' | 'categories') {
      try {
        const res = await getData<any>(`${BASE_URL.WEBFLOW}collections/${type}`);

        const { success, data, error } = res;
        if (success && data) {
          this.postsData[type] = data;
          return res;
        } else {
          throw new Error(error);
        }
      } catch (error) {
        if (error instanceof Error) throw error;
        throw new Error(error?.toString() ?? 'Unknown error!');
      }
    },
  },
});
